import { Button } from '@mui/material'
import { ColStack } from 'components/atoms/container/InCardStack'
import { InfoCardIcon } from 'components/atoms/Icons'
import { GridInfoStack } from 'components/atoms/InfoCard'
import { useTranslation } from 'react-i18next'
import shieldLockIcon from 'assets/images/shieldLock.svg'
import { AssessmentHeadWrapper } from 'components/molecules/assessments/AssessmentMolecules'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import colors from 'styles/colors'

const UserSurveyLanding = ({ handleBegin, fromOnboarding = false }) => {
  const { t } = useTranslation()

  return (
    <ColStack spacing={16}>
      <AssessmentHeadWrapper
        title={t(
          fromOnboarding
            ? 'userInsightSurvey.justAFewQuestions'
            : 'userInsightSurvey.justFollowupQuestions'
        )}
        description={t(
          fromOnboarding
            ? 'userInsightSurvey.questionDescription'
            : 'userInsightSurvey.followupQuestionDescription'
        )}
        containerSx={{
          backgroundColor: colors.MidnightTeal300
        }}>
        <GridInfoStack
          title={t('confidentiality.heading')}
          content={t(
            fromOnboarding
              ? 'userInsightSurvey.confidentialDescription'
              : 'userInsightSurvey.followupConfidentialDescription'
          )}
          icon={<InfoCardIcon src={shieldLockIcon} size={56} />}
          size={12}
          parentStackProps={{
            flexDirection: 'row',
            spacing: 0,
            gap: 12
          }}
          childStackProps={{
            sx: {
              alignItems: 'flex-start',
              '& .MuiTypography-root': {
                textAlign: 'start'
              }
            }
          }}
        />
      </AssessmentHeadWrapper>

      <Button onClick={handleBegin} endIcon={<ArrowForwardIcon />}>
        {t('userInsightSurvey.letsGo')}
      </Button>
    </ColStack>
  )
}

export default UserSurveyLanding
